export default function removeWhiteSpaces(value: string | undefined): string | undefined {
    return value?.replaceAll(" ", "").toLowerCase();
}
